var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnMinimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4C10.4478 4 10 4.44775 10 5V10.0001H5.00049C4.44824 10.0001 4.00049 10.4479 4.00049 11.0001C4.00049 11.5524 4.44824 12.0001 5.00049 12.0001H12V5C12 4.44775 11.5522 4 11 4Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.0001H27.0005C27.5527 12.0001 28.0005 11.5524 28.0005 11.0001C28.0005 10.4479 27.5527 10.0001 27.0005 10.0001H22V5C22 4.44775 21.5522 4 21 4C20.4478 4 20 4.44775 20 5V12.0001Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V27C20 27.5522 20.4478 28 21 28C21.5522 28 22 27.5522 22 27V22H27C27.5522 22 28 21.5522 28 21C28 20.4478 27.5522 20 27 20H20Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H5C4.44775 20 4 20.4478 4 21C4 21.5522 4.44775 22 5 22H10V27C10 27.5522 10.4478 28 11 28C11.5522 28 12 27.5522 12 27V20Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMinimize);
export default __webpack_public_path__ + "static/media/icn_minimize.48323cc3.svg";
export { ForwardRef as ReactComponent };